import { ActionsDropZone } from '@spa/scenes/Plannings/DnD/common/ActionsDropZone/ActionsDropZone'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import { weeklyschedulesSelectors } from '../../redux/selectors'
import { ForbiddenDropZone } from '../common/ForbiddenDropZone/ForbiddenDropZone'
import type { DragItemType } from '../constant'

import DropItemNoteCopy from './DropItemNoteCopy'
import DropItemNoteMove from './DropItemNoteMove'

type Props = {
  item: DragItemType
  weeklyscheduleId: number
  date: string
}

const NoteDropActions: FC<Props> = ({ item, weeklyscheduleId, date }) => {
  const { daily_notes = [] } =
    weeklyschedulesSelectors.useGetCachedById(weeklyscheduleId)

  const noteExist = useMemo(() => {
    return daily_notes.find(note => note.id === item.id)
  }, [daily_notes, item.id])

  if (!noteExist) {
    return <ForbiddenDropZone />
  }

  return (
    <ActionsDropZone>
      <DropItemNoteCopy weeklyscheduleId={weeklyscheduleId} day={date} />
      <DropItemNoteMove weeklyscheduleId={weeklyscheduleId} day={date} />
    </ActionsDropZone>
  )
}

export default NoteDropActions
